import React, { Component } from "react";
import { Col, Form, FormControl, FormGroup, FormLabel, Row } from "react-bootstrap";
import ValidatorUtils, { MAX_VALUE, MIN_VALUE, PRECISION, PROPS, RANGE_TYPE } from "../../../../utils/ValidatorUtils";

import PropTypes from "prop-types";
import DropdownButton from "react-bootstrap/DropdownButton";
import DropdownItem from "react-bootstrap/DropdownItem";
import { FormattedMessage, useIntl } from "react-intl";
import ObjectUtils, { coalesce } from "../../../../utils/ObjectUtils";
import QuestionHeader from "./QuestionHeader";

const { findByObjectProp } = ObjectUtils;

export default class Number extends Component {
  render() {
    const {
      changeQuestionField,
      setValidatorProperty,
      pageName,
      question,
      intl,
      loadIndicators,
      addIndicatorToQuestion,
      removeIndicatorFromQuestion,
      allIndicators,
      libraryQuestion
    } = this.props;
    return (
      <QuestionHeader
        changeQuestionField={changeQuestionField}
        pageName={pageName}
        question={question}
        addIndicatorToQuestion={addIndicatorToQuestion}
        removeIndicatorFromQuestion={removeIndicatorFromQuestion}
        intl={intl}
        loadIndicators={loadIndicators}
        allIndicators={allIndicators}
        libraryQuestion={libraryQuestion}
      >
        <ConfigComponent
          intl={intl}
          pageName={pageName}
          question={question}
          setValidatorProperty={setValidatorProperty}
          changeQuestionField={changeQuestionField}
        />
      </QuestionHeader>
    );
  }
}

Number.propTypes = {
  changeQuestionField: PropTypes.func,
  setValidatorProperty: PropTypes.func,
  loadIndicators: PropTypes.func,
  addIndicatorToQuestion: PropTypes.func,
  removeIndicatorFromQuestion: PropTypes.func,
  question: PropTypes.object,
  intl: PropTypes.object,
  allIndicators: PropTypes.array,
  pageName: PropTypes.string
};

const ConfigComponent = ({
  pageName,
  question,
  setValidatorProperty,
  changeQuestionField,
  columnName,
  predefinedProps,
  editable=true
}) => {
  const intl = useIntl();
  let { getDeepProperty } = ObjectUtils;
  let validatorsProp = coalesce(getDeepProperty(predefinedProps, "validators"), "validators");
  let suffixProp = coalesce(getDeepProperty(predefinedProps, "suffix"), "suffix");
  const validators = getDeepProperty(question, validatorsProp);
  const validator = !columnName
    ? getDeepProperty(validators, 0)
    : findByObjectProp(validators, "columnName", columnName);
  const minValue = coalesce(getDeepProperty(validator, PROPS, MIN_VALUE), "");
  const maxValue = coalesce(getDeepProperty(validator, PROPS, MAX_VALUE), "");
  const precision = coalesce(getDeepProperty(validator, PROPS, PRECISION), "0");

  // we need to set precision to 0 when not yet set as it shows "0" in the dropdown initially but is actually not set
  if (
    typeof getDeepProperty(validator, PROPS, PRECISION) === "undefined" ||
    getDeepProperty(validator, PROPS, PRECISION) === null
  ) {
    setValidatorProperty(pageName, question.name, RANGE_TYPE, PRECISION, precision, validatorsProp, columnName);
  }

  return (
    <Form>
      <Row className="flex-wrap gap-lg align-items-center">
        <FormGroup as={Col} className="d-flex align-items-center gap-lg mb-3" controlId="range">
          <FormLabel className="m-0">
            <FormattedMessage id="survey.editor.text.number.range" />
          </FormLabel>
          <FormControl
            className="w-25 number"
            disabled={!editable}
            placeholder={intl.formatMessage({ id: "survey.editor.text.number.from" })}
            onChange={(e) => {
              setValidatorProperty(
                pageName,
                question.name,
                RANGE_TYPE,
                MIN_VALUE,
                e.target.value,
                validatorsProp,
                columnName
              );
            }}
            onKeyDown={ValidatorUtils.handleIntNumberInput}
            value={minValue}
          />
          <FormLabel className="m-0">
            <FormattedMessage id="survey.editor.text.number.till" />
          </FormLabel>
          <FormControl
            className="w-25 number me-auto"
            disabled={!editable}
            onChange={(e) => {
              setValidatorProperty(
                pageName,
                question.name,
                RANGE_TYPE,
                MAX_VALUE,
                e.target.value,
                validatorsProp,
                columnName
              );
            }}
            onKeyDown={ValidatorUtils.handleIntNumberInput}
            value={maxValue}
          />
        </FormGroup>
        <FormGroup as={Col} className="flex-center-between gap-lg mb-3" controlId="suffix">
          <FormLabel className="m-0">
            <FormattedMessage id="survey.editor.text.number.suffix" />
          </FormLabel>
          <FormControl
            disabled={!editable}
            onChange={(e) => {
              changeQuestionField(pageName, question.name, suffixProp, e.target.value);
            }}
            value={question[suffixProp] ? question[suffixProp] : ""}
          />
        </FormGroup>
        <FormGroup as={Col} className="flex-center-between gap-lg mb-3" controlId="decimal">
          <FormLabel className="m-0">
            <FormattedMessage id="survey.editor.text.number.decimal" />
          </FormLabel>
          <DropdownButton
            className="me-auto"
            disabled={!editable}
            onSelect={(eventKey) => {
              setValidatorProperty(pageName, question.name, RANGE_TYPE, PRECISION, eventKey, validatorsProp, columnName);
            }}
            title={precision ? precision : "0"}
            id="precisionDropDown"
          >
            <DropdownItem eventKey={0}>0</DropdownItem>
            <DropdownItem eventKey={1}>1</DropdownItem>
            <DropdownItem eventKey={2}>2</DropdownItem>
            <DropdownItem eventKey={3}>3</DropdownItem>
            <DropdownItem eventKey={4}>4</DropdownItem>
          </DropdownButton>
        </FormGroup>
      </Row>
    </Form>
  );
};

Number.Config = ConfigComponent;

ConfigComponent.propTypes = {
  predefinedProps: PropTypes.object,
  columnName: PropTypes.string,
  changeQuestionField: PropTypes.func,
  setValidatorProperty: PropTypes.func,
  question: PropTypes.object,
  pageName: PropTypes.string,
  libraryQuestion: PropTypes.object
};
